import React, { Component } from 'react'
import PropTypes from 'prop-types'
import LegendTeamsoncall from './LegendTeamsoncall.jsx'
import CalendarTeamsoncall from './CalendarTeamsoncall.jsx'
//import _ from 'lodash'

class TeamsoncallComponent extends Component{
  componentDidMount() {
    this.props.fetchData()
  }

  render() {
    if (this.props.oncall.colors) {
      return <div className="row"><div className="col-sm-8"><CalendarTeamsoncall oncall={this.props.oncall}></CalendarTeamsoncall></div><div className="col-sm-3 offset-sm-1"><LegendTeamsoncall oncall={this.props.oncall}></LegendTeamsoncall></div></div>
    }
    return <div></div>
  }
}

TeamsoncallComponent.propTypes = {
  fetchData: PropTypes.func.isRequired,
  oncall: PropTypes.object.isRequired,
}

export default TeamsoncallComponent
